import { SagaIterator } from 'redux-saga'
import * as effects from 'redux-saga/effects'
import * as api from './api'
import * as actions from './actions'
import { formatErrorMessage } from '../../utils/helpers'
import * as Sentry from '@sentry/react'

function* fetchContest(): SagaIterator {
  try {
    const contests = yield effects.call(api.fetchContest)
    yield effects.put(actions.fetchContestSuccess(contests.data))
  } catch (error) {
    if (error.response.code === 404) {
      yield effects.put(actions.fetchContestSuccess(null))
    } else {
      console.warn('Cannot fetch contest', error)
      yield effects.put(actions.fetchContestFailure(formatErrorMessage(error)))
      Sentry.captureException(error)
    }
  }
}

function* fetchWorks(payload: {
  contest_id: string
  search: string
  size: number
  page: number
}): SagaIterator {
  try {
    const { contest_id, search, size, page } = payload
    const works = yield effects.call(
      api.fetchWorks,
      contest_id,
      search,
      size,
      page
    )
    yield effects.put(actions.fetchWorksSuccess(works.data, works.meta))
  } catch (error) {
    console.warn('Cannot fetch contest works', error)
    yield effects.put(actions.fetchWorksFailure(formatErrorMessage(error)))
    Sentry.captureException(error)
  }
}

function* watchFetchContest(): SagaIterator {
  yield effects.takeEvery(actions.fetchContest.toString(), fetchContest)
}

function* watchFetchWorks(): SagaIterator {
  yield effects.takeEvery(actions.fetchWorks.toString(), fetchWorks)
}

export default function* watchProfileContestsWorksList(): SagaIterator {
  yield effects.all([
    effects.fork(watchFetchContest),
    effects.fork(watchFetchWorks),
  ])
}
